(() => {
  const initialize = (root) => root.querySelectorAll('[data-tm-product-view]').forEach((button) => {
    if (button.dataset.ready) return;
    button.dataset.ready = 'true';
    const photo = button.querySelector('[data-tm-product-photo]');
    const set = button.querySelector('[data-tm-product-set]');
    const gift = button.querySelector('[data-tm-product-gift]');
    const config = window.TM_GIFT_AUTO_ADD || {};
    const qualified = config.qualifyAnyNonGiftItem === true || (config.qualifyingProductIds || []).map(String).includes(button.dataset.productId);
    if (gift && !qualified) gift.remove();
    if (!set.querySelector('[data-tm-product-gift]')) set.classList.add('tm-home-product-view__set--single');
    button.addEventListener('click', async () => {
      if (button.getAttribute('aria-busy') === 'true') return;
      const showSet = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-busy', 'true');
      try {
        const next = showSet ? set : photo;
        await Promise.all([...next.querySelectorAll('img')].map(async (img) => {
          img.loading = 'eager';
          await img.decode();
          if (!img.naturalWidth) throw new Error('Image unavailable');
        }));
        photo.hidden = showSet;
        set.hidden = !showSet;
        button.setAttribute('aria-pressed', String(showSet));
        button.setAttribute('aria-label', showSet ? button.dataset.labelMain : button.dataset.labelAlternate);
        delete button.dataset.imageError;
      } catch (_) {
        // Keep the already visible image if the alternate image cannot load.
        button.dataset.imageError = 'true';
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  });
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
